import React, {Fragment} from 'react';
import ReactDOM from 'react-dom';

function MenuIcon(id, classN, clickFn) {
    var ID = id ? id : "";
    var cln = classN ? classN : "";

    var clfn = null;
    if(clickFn) {
        clfn = function(evt) {
            clickFn();
            evt.stopPropagation();
            evt.preventDefault();
        }
    }

    //line-style ="fill:none;stroke:#FFFFFF;stroke-width:2;stroke-linecap:round;stroke-miterlimit:10;"
    var icon = <svg id={ID} className={cln} onClick={clfn} x="0px" y="0px" viewBox="0 0 54 54">
                    <circle cx="27" cy="27" r="27"/>
                    <line x1="15" y1="16" x2="39" y2="16"/>
                    <line x1="15" y1="27" x2="39" y2="27"/>
                    <line x1="15" y1="38" x2="39" y2="38"/>
                <g>
                </g>
                <g>
                </g>
                <g>
                </g>
                <g>
                </g>
                <g>
                </g>
                <g>
                </g>
                <g>
                </g>
                <g>
                </g>
                <g>
                </g>
                <g>
                </g>
                <g>
                </g>
                <g>
                </g>
                <g>
                </g>
                <g>
                </g>
                <g>
                </g>
                </svg>;

    return icon;
}

export default MenuIcon;


// WEBPACK FOOTER //
// ./src/MenuIcon.js